import { z } from 'zod'

export enum MedChronSourceProvider {
  USER_FILES = 'user_files',
}

// Med-chron sources use one user-files provider, so this is a single object schema.
export const MedChronSourceRefSchema = z.object({
  provider: z.literal(MedChronSourceProvider.USER_FILES),
  source_id: z.string(),
  display_name: z.string(),
})

export type MedChronSourceRef = z.infer<typeof MedChronSourceRefSchema>
